import React, { Fragment } from "react";
import "./disclaimer.scss";

const Disclaimer = () => {
  return (
    <Fragment>
      <div className="disclaimer">
        <div className="container1500">
          <h2>Disclaimer :</h2>
          <div className="desc">
            <p>
              <strong>Should I Claim Compensation</strong> is the trading name
              of National Injury Claimline Ltd. National Injury Claimline Ltd is
              regulated by the Financial Conduct Authority in respect of
              regulated claims management activities. Authorisation Number: FRN:
              837834. Company Registration Number: 09944369. Incorporated in
              England and Wales. Registered Office Address: Egerton House, The
              Towers Business Park, Didsbury, Manchester, M20 2DX. ICO
              Registration: ZA160649
            </p>
          </div>
        </div>
      </div>
    </Fragment>
  );
};

export default Disclaimer;
